jQuery(document).ready(function($) {
	if ($('body.page-template-page-about').length == 0) return;
});
